var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { getImageUrl, AllImageSizes } from '@domain-group/fe-allhomes-library/lib/enums/image-size';
import NewDevelopmentParentDetails from './new-development-parent-details';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment NewDevelopmentParentDetails on Property {\n    development {\n      website\n      children {\n        listing {\n          id\n          url\n          firstImage {\n            imageSrc\n          }\n          price\n          title\n        }\n        features {\n          propertyType\n          bedrooms\n          bathrooms {\n            bathrooms\n            ensuites\n          }\n          parking {\n            garages\n            carports\n            other\n          }\n        }\n      }\n    }\n  }\n"])));
var graphQLToProps = function graphQLToProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$development = _ref.development,
    development = _ref$development === void 0 ? {} : _ref$development;
  return {
    childListings: development.children.map(_ref2 => {
      var listing = _ref2.listing,
        features = _ref2.features;
      return {
        id: listing.id,
        url: listing.url,
        title: listing.title,
        images: {
          listingImage: listing.firstImage && getImageUrl(listing.firstImage.imageSrc, AllImageSizes.PHONE_LARGE),
          listingImageLowResolution: listing.firstImage && getImageUrl(listing.firstImage.imageSrc, AllImageSizes.SMALL)
        },
        price: listing.price,
        features: {
          beds: features.bedrooms,
          baths: features.bathrooms.bathrooms,
          ensuite: features.bathrooms.ensuites,
          garage: features.parking.garages,
          carport: features.parking.carports,
          parking: features.parking.other,
          propertyType: features.propertyType
        }
      };
    }),
    newDevelopmentWebsite: development.website
  };
};
var NewDevelopmentParentDetailsGraphQL = _ref3 => {
  var property = _ref3.property,
    title = _ref3.title;
  return ___EmotionJSX(NewDevelopmentParentDetails, _extends({}, graphQLToProps(property), {
    title: title
  }));
};
NewDevelopmentParentDetailsGraphQL.fragment = fragment;
NewDevelopmentParentDetailsGraphQL.propTypes = {
  property: PropTypes.shape({}),
  title: PropTypes.string
};
NewDevelopmentParentDetailsGraphQL.defaultProps = {
  property: {},
  title: undefined
};
export default NewDevelopmentParentDetailsGraphQL;